import React from "react";
import AboutUs from "../../components/AboutUs/AboutUs";
import OurServicesNew from "../../components/OurServices/OurServicesNew";

import Hero from "../../components/Hero/Hero";
import Banner from "../../components/Banner/Banner";
import HiringProcess from "../../components/HiringProcess/HiringProcess";
import TechStack from "../../components/TechStack/TechStack";
import OurValuesCard from "../../components/OurValuesCards/OurValuesCard";

import "./Home.css";

const Home = () => {
  return (
    <>
      <div id="home" className="innerWidth home-wrapper">
        <Hero />
        <AboutUs />
        <OurServicesNew />
        <OurValuesCard />
        <HiringProcess />
        <TechStack />
      </div>
      <Banner />
    </>
  );
};
export default Home;
